import { render, staticRenderFns } from "./Exceptions.vue?vue&type=template&id=8660f906"
import script from "./Exceptions.vue?vue&type=script&lang=ts"
export * from "./Exceptions.vue?vue&type=script&lang=ts"
import style0 from "./Exceptions.vue?vue&type=style&index=0&id=8660f906&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports